export default "__VITE_ASSET__b4a4b4e1__"